//**auto-generated don't edit this code**//
export enum SubjectType {
	Personal,
	Stock,
	Deployed,
}